// 시점 복구는 서버 셸 명령(sudo bricklit-restore)으로만 실행한다. 앱이 자기 DB·미디어를 갈아끼우며
// 재시작하는 건 위험해서, 화면은 어떤 세대를 골랐고 어떤 명령을 치면 되는지까지만 안내한다.
export type RestorableSet = { id: string; kind: 'db' | 'media'; remote: { status: 'not-configured' | 'pending' | 'success' | 'error' } };

export type RestorePlan = {
  /** 미디어까지 되돌리는지(media 세대) DB 만 되돌리는지(db 세대) */
  mode: 'full' | 'db';
  /** dry-run(격리 복구 + 검증만) 명령 */
  dryRun: string;
  /** 운영 데이터 교체 명령 */
  apply: string;
  /** 이 서버 백업이 사라졌을 때 S3 세대로 같은 복구를 하는 명령. 클라우드 업로드가 성공한 세대에만 있다 */
  fromS3: string | null;
  notes: string[];
};

export function restorePlan(set: RestorableSet): RestorePlan {
  const mode = set.kind === 'media' ? 'full' : 'db';
  const base = `sudo bricklit-restore ${set.id}`;
  const notes = mode === 'full'
    ? ['DB와 참조 미디어·썸네일을 이 세대 시점으로 되돌립니다. 이후 올린 콘텐츠는 사라집니다.', '교체 전 현재 data/ 는 pre-restore/ 로 옮겨 보관되고, /health 실패 시 자동으로 되돌아옵니다.']
    : ['DB 만 되돌리고 미디어 파일은 현행 유지입니다. 이 시점 이후 지운 미디어를 DB가 참조하면 그 항목은 재생되지 않습니다(명령이 누락 목록을 출력).', '미디어까지 되돌리려면 같은 날의 DB·참조 미디어 백업을 고르세요.'];
  return {
    mode,
    dryRun: base,
    apply: `${base} --apply`,
    fromS3: set.remote.status === 'success' ? `${base} --source s3 --apply` : null,
    notes,
  };
}
